import { render, staticRenderFns } from "./EditorBlockOpenCloze.vue?vue&type=template&id=3aeea576&scoped=true"
import script from "./EditorBlockOpenCloze.vue?vue&type=script&lang=js"
export * from "./EditorBlockOpenCloze.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockOpenCloze.vue?vue&type=style&index=0&id=3aeea576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeea576",
  null
  
)

export default component.exports